import { useState, useCallback } from "react";
import { companyService } from "@/services/company-service";

export function useCompanySelection({
  defaultCompanies,
}: {
  defaultCompanies?: { value: string; label: string }[];
}) {
  const [companies, setCompanies] = useState<
    { value: string; label: string }[]
  >(defaultCompanies ?? []);
  const [companyPackages, setCompanyPackages] = useState<
    { value: string; label: string }[]
  >([]);

  const handleSearchCompanies = useCallback(async (term: string) => {
    if (term.length < 3) {
      setCompanies([]);
      return;
    }

    const results = await companyService.searchCompanies({ term });
    setCompanies(
      results.map((company) => ({
        value: company.id.toString(),
        label: company.name,
      })),
    );
  }, []);

  const handleCompanySelect = useCallback(
    async ({
      companyId,
      hasFilterAvailability,
    }: {
      companyId: string;
      hasFilterAvailability?: boolean;
    }) => {
      const companyPackages = await companyService.getCompanyPackages({
        companyId: Number(companyId),
        take: 1000,
      });

      const filteredPackages = companyPackages
        .filter(
          (pkg) =>
            !hasFilterAvailability ||
            (pkg.products.includes("PO") &&
              pkg.versions.some((v) =>
                ["active", "awaiting"].includes(v.status),
              )),
        )
        .map((companyPackage) => ({
          value: companyPackage.id.toString(),
          label: companyPackage.name,
        }));

      setCompanyPackages(filteredPackages);

      return companyPackages;
    },
    [],
  );

  return {
    companies,
    companyPackages,
    handleSearchCompanies,
    handleCompanySelect,
  };
}
